import React from 'react';
import { isIOS, isSafari } from 'react-device-detect';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PortraitPaperLayout from '../@common/portrait/PortraitPaperLayout';
import PageLines from '../@common/PageLines';
import { LargePageLineText } from '../@common/PageLineText';
import BaseInput from '../@common/BaseInput';
import GroupedPageLines from '../@common/GroupedPageLines';
import NameAndDateLines from '../@common/NameAndDateLines';
import SmallBoxBorderLines from 'html-worksheets/@common/SmallBoxBorderLines';
import { determineStyleBasedOnLineWidth } from 'utils/style-utils';
import { translate } from '../../translations/translator';
const t = key => translate('worksheet', key);
const smallSections = [t('characters'), t('setting')];

const StoryOrganizer = ({ onChange, isCursive, isNarrow, valueMap, printRef }) => {
  const bookFont = isCursive ? 'Cursive-Book' : 'Print-Wide-Book';
  const numOfLines = isNarrow ? 5 : 3;
  const lineArray = [...Array(numOfLines).keys()];
  const marginTop = determineStyleBasedOnLineWidth(isCursive, isNarrow, {
    cursiveAndNarrow: isIOS || isSafari ? '-22px' : '-28px',
    narrow: '-16px',
    cursive: isIOS || isSafari ? '-28px' : '-37px',
    regular: '-22px'
  });
  const fontSize = determineStyleBasedOnLineWidth(isCursive, isNarrow, {
    cursiveAndNarrow: 42,
    narrow: 30,
    cursive: 55,
    regular: 40
  });
  const inputMarginTop = determineStyleBasedOnLineWidth(isCursive, isNarrow, {
    cursiveAndNarrow: isSafari || isIOS ? '11px' : '-3px',
    narrow: isSafari || isIOS ? '3px' : '-3px',
    cursive: isSafari || isIOS ? '6px' : '-10px',
    regular: '-4px'
  });

  const plotPadding = isNarrow ? '0 0 40px' : '0 0 25px';
  const smallBoxPaddingBottom = isNarrow ? '0px' : '0px';

  const classes = useStyles({ inputMarginTop });

  return (
    <PortraitPaperLayout
      isNarrow={isNarrow}
      printRef={printRef}
      className="print-full-page-height-and-width"
    >
      <NameAndDateLines isCursive={isCursive} fontFamily={bookFont} isNarrow={isNarrow} top={20} />
      <PageLines width={800} className={classes.pageLine} isNarrow={isNarrow}>
        <LargePageLineText className={classes.pageLineText}>
          <BaseInput
            // eslint-disable-next-line
            onChange={({ target }) => onChange({ [1]: target.value })}
            showBackground={true}
            fontFamily={bookFont}
            color="#000"
            placeholder="Enter book or story title"
            className={classes.input}
            fontSize={fontSize}
            maxLength={60}
            value={valueMap[1]}
          />
        </LargePageLineText>
      </PageLines>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-evenly',
          flex: 1,
          width: '100%'
        }}
      >
        {smallSections.map((section, index) => {
          const characters = t('characters');
          const setting = t('setting');
          const sections = [characters, setting];
          const sectionName = sections[index];
          return (
            <SmallBoxBorderLines
              key={section}
              pageLineCount={5}
              firstLineText={sectionName}
              paddingBottom={smallBoxPaddingBottom}
              fontSize={fontSize}
              marginTopText={marginTop}
              fontFamily={bookFont}
              isNarrow={isNarrow}
              marginPageLines={isNarrow ? '-3px 25px 45px' : '10px 25px 45px'}
            />
          );
        })}
      </Box>
      <Box className={classes.bxContainer}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            padding: plotPadding
          }}
        >
          <GroupedPageLines
            top={40}
            fontSize={fontSize}
            color="black"
            marginLeftText={3}
            marginTopText={marginTop}
            fontFamily={bookFont}
            isNarrow={isNarrow}
          >
            {t('plot')}
          </GroupedPageLines>
          {lineArray.map((x, idx) => (
            <GroupedPageLines
              key={idx}
              top={isNarrow ? 45 : 30}
              isNarrow={isNarrow}
              marginPageLines={isNarrow ? '-3px 25px 45px' : '10px 25px 45px'}
            />
          ))}
        </Box>
      </Box>
    </PortraitPaperLayout>
  );
};

const useStyles = makeStyles(() => ({
  pageLine: {
    alignSelf: 'center !important',
    margin: '150px 25px 15px !important',
    position: 'relative',
    top: '-50px !important',
    left: '0px !important'
  },
  pageLineText: {
    justifyContent: 'space-between !important',
    width: '514px !important',
    marginLeft: '20px !important',
    fontSize: '30px !important',
    marginTop: '-26px !important'
  },
  input: ({ inputMarginTop }: any) => ({
    width: '800px !important',
    marginLeft: '-20px !important',
    paddingLeft: '10px',
    marginTop: `${inputMarginTop} !important`,
    color: 'black'
  }),
  bxContainer: {
    display: 'flex',
    flexDirection: 'column',
    border: '2px solid #000',
    borderRadius: '25px',
    margin: '40px',
    width: 'max-content',
    alignSelf: 'center'
    // '@media print': {
    //   width: '800px'
    // }
  }
}));
export default StoryOrganizer;
